import { api } from './apiClient'

/**
 * Extract a numeric field value from the first record in a BlRecordResponseDTO array.
 * Returns 0 if the field is absent or non-numeric.
 */
export function eavField(records, fieldName) {
  const field = records?.[0]?.fields?.find(f => f.fieldName === fieldName)
  return Number(field?.value ?? 0)
}

export const FinancialDataApi = {
  getFinancials(investmentId) {
    return api.get(`/api/investments/${investmentId}/financials`)
  },

  getInvestmentFinancialsByType(investmentId, typeName) {
    return api.get(`/api/investments/${investmentId}/financials/${typeName}`)
  },

  getFundFinancialsByType(fundId, typeName) {
    return api.get(`/api/funds/${fundId}/financials/${typeName}`)
  },

  /**
   * Fetch latest EAV records for multiple investments and multiple type names
   * in a single round trip.
   *
   * @param {string[]} ids   - Array of investment UUIDs
   * @param {string[]} types - Array of type names, e.g. ['investment_financials', 'investment_overview']
   * @returns {Promise<Object>} Map of { [investmentId]: { [typeName]: BlRecordResponseDTO[] } }
   */
  batchGetInvestmentFinancials(ids, types) {
    return api.post('/api/investments/financials/batch', { ids, types })
  }
}
